(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/constants.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/constants.js');

'use strict';

const isServer = svs.isServer;
const loginType = {
  BANKID: 'bankid',
  FREJAEID: 'frejaeid'
};
const route = {
  LOGIN_HOME_ROUTE: '/',
  REGISTRATE_HOME_ROUTE: '/registrering',
  LOGIN_BANKID_ROUTE: '/inloggning/bankid',
  REGISTRATE_BANKID_ROUTE: '/registrering/bankid',
  LOGIN_BANKID_START_ROUTE: '/inloggning/bankid/start',
  LOGIN_BANKID_POLL_QR_ROUTE: '/inloggning/bankid/qr',
  LOGIN_BANKID_POLL_APP_ROUTE: '/inloggning/bankid/app',
  REGISTRATE_BANKID_START_ROUTE: '/registrering/bankid/start',
  REGISTRATE_BANKID_POLL_QR_ROUTE: '/registrering/bankid/qr',
  REGISTRATE_BANKID_POLL_APP_ROUTE: '/registrering/bankid/app',
  LOGIN_FREJAEID_ROUTE: '/inloggning/frejaeid',
  REGISTRATE_FREJAEID_ROUTE: '/registrering/frejaeid',
  LOGIN_FREJAEID_START_ROUTE: '/inloggning/frejaeid/start',
  LOGIN_FREJAEID_POLL_QR_ROUTE: '/inloggning/frejaeid/qr',
  LOGIN_FREJAEID_POLL_APP_ROUTE: '/inloggning/frejaeid/app',
  REGISTRATE_FREJAEID_POLL_ROUTE: '/registrering/frejaeid/start',
  REGISTRATE_FREJAEID_POLL_QR_ROUTE: '/registrering/frejaeid/qr',
  REGISTRATE_FREJAEID_POLL_APP_ROUTE: '/registrering/frejaeid/app'
};

const bankidProgressStatus = {
  ERROR_POLL: -1,
  BEFORE_POLL: 0,
  SHOWING_QRCODE: 1,
  WAITING_SSNAPP: 1,
  WAITING_APP: 1,
  WAITING_CLIENT: 2,
  SHOWING_SPINNER: 4,
  ONLINE_CUSTOMER: 6,
  NEW_CUSTOMER: 20,
  RETAIL_CUSTOMER: 21,
  REACTIVATED_CUSTOMER: 22
};
const bankIdErrorCodes = {
  CUSTOMER_IDENTIFY_TIMEOUT: 49,
  CUSTOMER_SCAN_TIMEOUT: 56
};
const frejaeIdProgressStatus = {
  ERROR_POLL: -1,
  BEFORE_POLL: 0,
  WAITING_APP: 1,
  SHOWING_QRCODE: 1,
  SHOWING_SPINNER: 2,
  USER_DECLINED: 3,
  SVS_DECLINED: 4,
  CLIENT_TIMEOUT: 5,
  ONLINE_CUSTOMER: 6,
  DUPLICATED_AUTHTOKEN: 7,
  NEW_CUSTOMER: 20,
  RETAIL_CUSTOMER: 21,
  REACTIVATED_CUSTOMER: 22
};
const frejaeIdErrorCodes = {
  AUTHREF_NOT_FOUND_OR_EXPIRED: 71
};


const frejaeIdLevel = {
  NONE: 0,
  EXTENDED: 1,
  PLUS: 2
};

const appWaitStatus = {
  NO_WAIT: 'nowait',
  WAITING_QRCODE: 'qrcode',
  WAITING_SSNAPP: 'ssnapp',
  WAITING_APP: 'app',
  WAITING_CUSTOMER: 'customer'
};
const bankIdPollType = {
  BEFORE_POLL: 'beforepoll',
  SSN_INPUT: 'ssninput',
  WAITING_POLL: 'waitingpoll',
  SPINNER_POLL: 'spinnerpoll',
  USER_TIMEOUT: 'usertimeout'
};
const frejaeIdPollType = {
  BEFORE_POLL: 'beforepoll',
  WAITING_POLL: 'waitingpoll',
  SSN_INPUT: 'ssninput',
  SAME_DEVICE_POLL: 'samedevicepoll',
  SPINNER_POLL: 'spinnerpoll',
  USER_TIMEOUT: 'usertimeout'
};
const allowedGames = {
  EUROJACKPOT: 'eurojackpot',
  TRISS: 'triss',
  LOTTO: 'lotto',
  KENO: 'keno',
  VIKINGLOTTO: 'vikinglotto',
  SUPPORTERN: 'supportern'
};
const constExports = {
  allowedGames,
  appWaitStatus,
  bankIdPollType,
  bankidProgressStatus,
  bankIdErrorCodes,
  frejaeIdLevel,
  frejaeIdPollType,
  frejaeIdProgressStatus,
  frejaeIdErrorCodes,
  loginType,
  route
};
if (isServer) {
  module.exports = constExports;
} else {
  svs.playerLoginReact.constants = constExports;
}

 })(window);